module.exports = __webpack_public_path__ + "static/media/img_calendar_EN.40f3272f.png";